export const APPROVE_DECLINE_BY_TIMESHEETS_OR_ENTRIES_ASYNC_REQUEST = 'APPROVE_DECLINE_BY_TIMESHEETS_OR_ENTRIES_ASYNC_REQUEST';
export const APPROVE_DECLINE_BY_TIMESHEETS_OR_ENTRIES_REQUEST_FAILURE = 'APPROVE_DECLINE_BY_TIMESHEETS_OR_ENTRIES_REQUEST_FAILURE';
export const APPROVE_DECLINE_BY_TIMESHEETS_OR_ENTRIES_REQUEST_SUCCESS = 'APPROVE_DECLINE_BY_TIMESHEETS_OR_ENTRIES_REQUEST_SUCCESS';

export const APPROVE_DECLINE_BY_CUSTOMER_OR_PROJECT_REQUEST = 'APPROVE_DECLINE_BY_CUSTOMER_OR_PROJECT_REQUEST';
export const APPROVE_DECLINE_BY_CUSTOMER_OR_PROJECT_REQUEST_FAILURE = 'APPROVE_DECLINE_BY_CUSTOMER_OR_PROJECT_REQUEST_FAILURE';
export const APPROVE_DECLINE_BY_CUSTOMER_OR_PROJECT_REQUEST_SUCCESS = 'APPROVE_DECLINE_BY_CUSTOMER_OR_PROJECT_REQUEST_SUCCESS';

/*
 *    DONE
 */

export const GET_DONE_APPROVALS_ALL_REQUEST = 'GET_DONE_APPROVALS_ALL_REQUEST';
export const GET_DONE_APPROVALS_ALL_REQUEST_FAILURE = 'GET_DONE_APPROVALS_ALL_REQUEST_FAILURE';
export const GET_DONE_APPROVALS_ALL_REQUEST_SUCCESS = 'GET_DONE_APPROVALS_ALL_REQUEST_SUCCESS';

export const GET_DONE_APPROVALS_ALL_NEXT_PAGE_REQUEST = 'GET_DONE_APPROVALS_ALL_NEXT_PAGE_REQUEST';
export const GET_DONE_APPROVALS_ALL_NEXT_PAGE_REQUEST_FAILURE = 'GET_DONE_APPROVALS_ALL_NEXT_PAGE_REQUEST_FAILURE';
export const GET_DONE_APPROVALS_ALL_NEXT_PAGE_REQUEST_SUCCESS = 'GET_DONE_APPROVALS_ALL_NEXT_PAGE_REQUEST_SUCCESS';

export const GET_DONE_APPROVALS_TIMESHEET_REQUEST = 'GET_DONE_APPROVALS_TIMESHEET_REQUEST';
export const GET_DONE_APPROVALS_TIMESHEET_REQUEST_FAILURE = 'GET_DONE_APPROVALS_TIMESHEET_REQUEST_FAILURE';
export const GET_DONE_APPROVALS_TIMESHEET_REQUEST_SUCCESS = 'GET_DONE_APPROVALS_TIMESHEET_REQUEST_SUCCESS';

export const GET_DONE_APPROVALS_TIMESHEET_NEXT_PAGE_REQUEST = 'GET_DONE_APPROVALS_TIMESHEET_NEXT_PAGE_REQUEST';
export const GET_DONE_APPROVALS_TIMESHEET_NEXT_PAGE_REQUEST_FAILURE = 'GET_DONE_APPROVALS_TIMESHEET_NEXT_PAGE_REQUEST_FAILURE';
export const GET_DONE_APPROVALS_TIMESHEET_NEXT_PAGE_REQUEST_SUCCESS = 'GET_DONE_APPROVALS_TIMESHEET_NEXT_PAGE_REQUEST_SUCCESS';

/*
 *    TODO
 */
export const GET_TODO_APPROVALS_GROUPS_REQUEST = 'GET_TODO_APPROVALS_GROUPS_REQUEST';
export const GET_TODO_APPROVALS_GROUPS_REQUEST_FAILURE = 'GET_TODO_APPROVALS_GROUPS_REQUEST_FAILURE';
export const GET_TODO_APPROVALS_GROUPS_REQUEST_SUCCESS = 'GET_TODO_APPROVALS_GROUPS_REQUEST_SUCCESS';

export const GET_TODO_APPROVALS_GROUPS_NEXT_PAGE_REQUEST = 'GET_TODO_APPROVALS_GROUPS_NEXT_PAGE_REQUEST';
export const GET_TODO_APPROVALS_GROUPS_NEXT_PAGE_REQUEST_FAILURE = 'GET_TODO_APPROVALS_GROUPS_NEXT_PAGE_REQUEST_FAILURE';
export const GET_TODO_APPROVALS_GROUPS_NEXT_PAGE_REQUEST_SUCCESS = 'GET_TODO_APPROVALS_GROUPS_NEXT_PAGE_REQUEST_SUCCESS';

export const GET_TODO_APPROVALS_ACTIVE_REQUEST = 'GET_TODO_APPROVALS_ACTIVE_REQUEST';
export const GET_TODO_APPROVALS_ACTIVE_REQUEST_FAILURE = 'GET_TODO_APPROVALS_ACTIVE_REQUEST_FAILURE';
export const GET_TODO_APPROVALS_ACTIVE_REQUEST_SUCCESS = 'GET_TODO_APPROVALS_ACTIVE_REQUEST_SUCCESS';

export const GET_TODO_APPROVALS_ACTIVE_NEXT_PAGE_REQUEST = 'GET_TODO_APPROVALS_ACTIVE_NEXT_PAGE_REQUEST';
export const GET_TODO_APPROVALS_ACTIVE_NEXT_PAGE_REQUEST_FAILURE = 'GET_TODO_APPROVALS_ACTIVE_NEXT_PAGE_REQUEST_FAILURE';
export const GET_TODO_APPROVALS_ACTIVE_NEXT_PAGE_REQUEST_SUCCESS = 'GET_TODO_APPROVALS_ACTIVE_NEXT_PAGE_REQUEST_SUCCESS';

export const GET_TODO_APPROVALS_SELECTED_REQUEST = 'GET_TODO_APPROVALS_SELECTED_REQUEST';
export const GET_TODO_APPROVALS_SELECTED_REQUEST_FAILURE = 'GET_TODO_APPROVALS_SELECTED_REQUEST_FAILURE';
export const GET_TODO_APPROVALS_SELECTED_REQUEST_SUCCESS = 'GET_TODO_APPROVALS_SELECTED_REQUEST_SUCCESS';

export const GET_TODO_APPROVALS_SELECTED_NEXT_PAGE_REQUEST = 'GET_TODO_APPROVALS_SELECTED_NEXT_PAGE_REQUEST';
export const GET_TODO_APPROVALS_SELECTED_NEXT_PAGE_REQUEST_FAILURE = 'GET_TODO_APPROVALS_SELECTED_NEXT_PAGE_REQUEST_FAILURE';
export const GET_TODO_APPROVALS_SELECTED_NEXT_PAGE_REQUEST_SUCCESS = 'GET_TODO_APPROVALS_SELECTED_NEXT_PAGE_REQUEST_SUCCESS';
